export function getCognitoErrorCode(error: unknown): string | undefined {
    if (!error || typeof error !== 'object') {
        return undefined;
    }

    const candidate = error as { code?: string; name?: string };
    return candidate.code || candidate.name;
}

export function getCognitoErrorMessage(error: unknown): string {
    if (!error || typeof error !== 'object') {
        return '';
    }

    const message = (error as { message?: string }).message;
    return typeof message === 'string' ? message : '';
}

export function isUnverifiedContactResetPasswordError(error: unknown): boolean {
    const code = getCognitoErrorCode(error);
    if (code !== 'InvalidParameterException') {
        return false;
    }

    const message = getCognitoErrorMessage(error).toLowerCase();
    return (
        message.includes('no registered/verified email') ||
        message.includes('verified email or phone')
    );
}

export function isUserAlreadyConfirmedError(error: unknown): boolean {
    const message = getCognitoErrorMessage(error).toLowerCase();
    return (
        message.includes('already confirmed') ||
        message.includes('current status is confirmed')
    );
}
